export const sysParams = (state) => state.sysParams;

export const userInfo = (state) => state.userInfo;

export const roles = (state) => state.userInfo.roles;

export const routes = (state) => state.routes;

export const addRouters = (state) => state.addRouters;

export const isLogin = (state) => () => {
    let auth = localStorage.getItem('Authorization');
    state.isLogin = auth === 'true' ? true : false;
    return state.isLogin;
};

export const membershipDialog = (state) => state.membershipDialog;

export const materialDetailDialog = (state) => state.materialDetailDialog;

export const platform= (state) => state.platform;